import React, { useState } from 'react';
import './VirtualCFO.css';

function Bookkeeping() {
  const [activeIndex, setActiveIndex] = useState(null);

  const offerings = [
    {
      title: 'Bookkeeping',
      content: [
        'Recording day-to-day financial transactions with accuracy',
        'Bank, credit card, and cash reconciliations',
        'Maintaining general ledger and subsidiary ledgers',
        'Handling accounts payable/receivable and invoicing',
        'Month-end and year-end closing support'
      ]
    },
    {
      title: 'Accounting & Reporting',
      content: [
        'Preparation of financial statements (P&L, balance sheet, cash flow)',
        'Budgeting and forecasting reports',
        'Variance analysis and expense tracking',
        'Custom MIS reports tailored to business needs',
        'Compliance reporting as per statutory requirements'
      ]
    },
    {
      title: 'Audit Support',
      content: [
        'Year-end schedules and audit-ready financials',
        'Coordination with external auditors',
        'Review and documentation of financial records',
        'Support for statutory and internal audits'
      ]
    },
    {
      title: 'Process Optimization',
      content: [
        'Automating recurring accounting tasks',
        'Designing workflows for better recordkeeping',
        'Implementing accounting software solutions',
        'Review of internal controls and process gaps'
      ]
    }
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className="service-page">
      {/* Hero Section */}
      <section
        className="hero-image-section"
        style={{ backgroundImage: "url('/images/bookkeeping_hero.png')" }}
      >
        <div className="hero-text-container">
          <h1>Bookkeeping & Accounting</h1>
          <p>Accurate financials and real-time visibility for growing businesses</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="service-content">
        <div className="content-left">
          <h2>Smarter Accounting & Stronger Compliance.</h2>
          <p>We manage daily transactions, ledgers, reconciliations, and financial reports with complete accuracy.</p>
          <p>Our team ensures every financial record is timely, traceable, and compliant with the latest regulations.</p>
          <p>Our services help you make informed business decisions and maintain investor-ready financials.</p>
          <p>We turn complex data into clear insights — helping you plan, forecast, and grow with confidence.</p>
          <p>With FINTEXL, you get professional accounting systems that scale with your operations, whether you're a startup or an expanding enterprise.</p>
          <p>We go beyond bookkeeping — empowering your business with reliable financial clarity and long-term compliance.</p>
        </div>
      </section>

      {/* Accordion Section */}
      <section className="accordion-section">
        <h2>Our Offerings</h2>
        <div className="accordion-container">
          {offerings.map((item, index) => (
            <div key={index} className={`accordion-item ${activeIndex === index ? 'active' : ''}`}>
              <div className="accordion-header" onClick={() => toggleAccordion(index)}>
                <span>{activeIndex === index ? '−' : '+'}</span> {item.title}
              </div>
              {activeIndex === index && (
                <div className="accordion-body">
                  <ul>
                    {item.content.map((point, idx) => (
                      <li key={idx}>{point}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Bookkeeping;


